// extracted by mini-css-extract-plugin
export default {"tags":"education-list-maker_tags__8B8Cy"};